// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalPromotion_modal__286To","modalCloseButton":"ModalPromotion_modalCloseButton__1JeqN","container":"ModalPromotion_container__547wj"};